<template>
    <div class="menu-page">
        <div v-if="!currentUser.account.campaigns_enabled || !currentUser.account.max_official_channels || currentUser.account.max_official_channels < 1">
            <v-alert class="fade" text dense type="error">
                <b>API Oficial</b> não disponível para essa conta. Para upgrade e mais informações, clique no botão abaixo.

                <div>
                    <ib-btn color="primary" class="mt-2" @click.native="callSupport">
                        <v-icon>mdi-face-agent</v-icon>Falar com o suporte
                    </ib-btn>
                </div>
            </v-alert>
        </div>

        <div v-if="!(!currentUser.account.campaigns_enabled || !currentUser.account.max_official_channels || currentUser.account.max_official_channels < 1)">
            <v-card class="nd-border" flat>
                <v-card-title>
                    Campanhas de API Oficial
                </v-card-title>

                <v-card-subtitle>
                    Crie campanhas para enviar mensagens em massa para seus contatos. Segmente envios de fluxo ou mensagens de texto. <ib-btn small @click="showVideo = true"><v-icon size="16" class="mr-1">mdi-help-circle-outline</v-icon>Saiba mais</ib-btn>
                </v-card-subtitle>

                <v-card-text v-if="showAlert || showAlert2">
                    <v-alert v-if="showAlert" class="fade" dense text type="error" dismissible>
                        Sua conta não possui nenhum número conectado. Será necessário conectar um número/chip para fazer o envio.
                        <div>
                            <v-btn class="mt-2" color="error" @click.native="$router.push('/chips')">
                                Conectar número
                            </v-btn>
                        </div>
                    </v-alert>
                </v-card-text>

                <v-card-text>
                    <div v-if="!showAlert">
                        <v-row>
                            <v-col cols="12" class="d-flex">
                                <v-spacer></v-spacer>
                                <ib-btn color="primary" class="mr-2" @click.native="$router.push({ name: 'Templates' })">
                                    Templates de mensagem
                                </ib-btn>
                                <ib-btn color="primary" @click.native="openNew">
                                    <v-icon left>mdi-plus</v-icon>
                                    Nova campanha
                                </ib-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table :headers="headers" :items="objects">
                                    <template #[`item.created`]="{ item }">
                                        {{ new Date(item.created).toLocaleString('pt-BR').replace(',', ' -') }}
                                    </template>

                                    <template #[`item.scheduledTo`]="{ item }">
                                        {{ item.scheduledTo ? new
                                            Date(item.scheduledTo).toLocaleString('pt-BR').replace(',', ' -') : 'Imediato'
                                        }}
                                    </template>

                                    <template #[`item.status`]="{ item }">
                                        {{ statuses[item.status] }}
                                    </template>

                                    <template #[`item.audience`]="{ item }">
                                        {{ getAudience(item.audience) }}
                                    </template>

                                    <template #[`item.sent_messages`]="{ item }">
                                        <div v-if="item.status != 'started'">
                                            {{ item.sent_messages }}
                                        </div>
                                        <div v-else>
                                            Enviando...
                                        </div>
                                    </template>

                                    <template #[`item.actions`]="{ item }">
                                        <v-menu>
                                            <template #activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-dots-horizontal</v-icon>
                                                </v-btn>
                                            </template>

                                            <v-card>
                                                <v-list-item @click="openObject(item)">
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-file-edit-outline</v-icon>
                                                    </v-list-item-icon>

                                                    <v-list-item-content>
                                                        <v-list-item-title>Editar</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item @click="duplicateObject(item)">
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-content-duplicate</v-icon>
                                                    </v-list-item-icon>

                                                    <v-list-item-content>
                                                        <v-list-item-title>Duplicar</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item v-if="item.status === 'started'" @click="selectedItem = item; openRealTime(item._id)">
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-eye-outline</v-icon>
                                                    </v-list-item-icon>

                                                    <v-list-item-content>
                                                        <v-list-item-title>Acompanhar em tempo real</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item v-if="!['canceled', 'finished'].includes(item.status)" @click="object = item; dialog2 = true">
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-close-circle</v-icon>
                                                    </v-list-item-icon>

                                                    <v-list-item-content>
                                                        <v-list-item-title>Cancelar</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item @click="object = item; dialog = true">
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-trash-can-outline</v-icon>
                                                    </v-list-item-icon>

                                                    <v-list-item-content>
                                                        <v-list-item-title>Apagar</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-card>
                                        </v-menu>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>

            <ib-dialog v-model="dialogCreate" scrollable max-width="1200">
                <v-card>
                    <ib-dialog-header title="Campanha" subtitle="Envie mensagens em massa para um público cadastrado." :close="() => { getObjects(); dialogCreate = false }"></ib-dialog-header>

                    <v-card-text class="pt-1">
                        <v-row>
                            <v-col cols="12" lg="6" md="6" sm="12">
                                <ib-text-field v-model="object.name" label="Nome da campanha" placeholder="Insira o nome da campanha" outlined hide-details="auto" />
                            </v-col>

                            <v-col cols="12" lg="6" md="6" sm="12">
                                <ib-autocomplete v-model="object.chip" clearable item-text="name" item-value="_id" :items="chips" return-object label="Chip de envio" outlined hide-details="auto" />
                            </v-col>

                            <v-col cols="12" lg="6" md="6" sm="12">
                                <ib-autocomplete v-model="object.audience_type" clearable item-text="name" item-value="id" :items="types" label="Público de envio" outlined hide-details="auto" />
                            </v-col>

                            <v-col v-if="object.audience_type == 'audience'" cols="12" lg="6" md="6" sm="12">
                                <ib-autocomplete v-model="object.audience" clearable item-text="name" item-value="_id" :items="audiences" label="Público ou audiência" outlined hide-details="auto" />
                            </v-col>

                            <v-col v-if="object.audience_type == 'tags'" cols="12" lg="6" md="6" sm="12">
                                <ib-autocomplete v-model="object.audience_tags" chips small-chips multiple outlined :items="tags" item-text="name" item-value="_id" label="Enviar para quem possui qualquer uma das tags" hide-details="auto">
                                    <template #selection="{ item }">
                                        <ib-chip small :color="item.color">
                                            {{ item.name }}
                                        </ib-chip>
                                    </template>
                                </ib-autocomplete>
                            </v-col>

                            <v-col v-if="object.audience_type == 'tags'" cols="12" lg="6" md="6" sm="12">
                                <ib-autocomplete v-model="object.audience_tags_skip" chips small-chips multiple outlined :items="tags" item-text="name" item-value="_id" label="NÃO enviar se possuir qualquer uma das tags" hide-details="auto">
                                    <template #selection="{ item }">
                                        <ib-chip small :color="item.color">
                                            {{ item.name }}
                                        </ib-chip>
                                    </template>
                                </ib-autocomplete>
                            </v-col>

                            <v-col cols="12" lg="6" md="6" sm="12">
                                <ib-autocomplete v-model="object.template" clearable :items="templates" label="Template da mensagem" item-text="name" return-object outlined hide-details="auto" messages="O template precisa estar aprovado pela Meta" @change="templateChanged" />
                            </v-col>

                            <v-col cols="12" lg="6" md="6" sm="12">
                                <v-datetime-picker v-model="object.scheduledTo" label="Data e hora do envio" date-format="dd/MM/yyyy" :date-picker-props="{ locale: 'pt-BR' }" :time-picker-props="{ format: '24hr' }" :text-field-props="{ outlined: true, 'hide-details': 'auto' }">
                                    <template slot="dateIcon">
                                        <v-icon>mdi-calendar</v-icon>
                                    </template>

                                    <template slot="timeIcon">
                                        <v-icon>mdi-clock-outline</v-icon>
                                    </template>

                                    <template slot="actions" slot-scope="{ parent }">
                                        <ib-btn color="error lighten-1" outlined @click.native="parent.clearHandler">
                                            Cancelar
                                        </ib-btn>
                                        <ib-btn color="success en-1" @click="parent.okHandler">
                                            OK
                                        </ib-btn>
                                    </template>
                                </v-datetime-picker>
                            </v-col>

                            <v-col cols="12" v-if="object.template">
                                <h2 class="mb-1">Conteúdo do template</h2>
                                <span>{{object.template.components.find(c => c.type === 'BODY')?.text}}</span>
                                <br>

                                <v-row class="mt-2" v-for="(par, index) in object.template_parameters" :key="`parameter_${index}`">
                                    <v-col cols="6">
                                        <ib-text-field v-model="par.var" :label="`Variável do parâmetro ${index + 1}`" placeholder="Insira o nome da variável do contato que substituirá esse parâmetro" outlined hide-details="auto" />
                                    </v-col>

                                    <v-col cols="6">
                                        <ib-text-field v-model="par.fallback" :label="`Fallback do parâmetro ${index + 1}`" placeholder="Valor padrão caso a variável não exista no contato" outlined hide-details="auto" />
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" v-if="object.template_payloads">
                                <h2 class="mb-1">Interações com o template</h2>

                                <v-row class="mt-2">
                                    <v-col cols="12" v-for="(btn, index) in object.template_payloads" :key="`payload_${index}`">
                                        <ib-autocomplete v-model="btn.payload" clearable item-text="name" item-value="_id" :items="flows" :label="btn.tip" outlined hide-details="auto" />
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12">
                                <h2 class="mb-1">Criação das conversas</h2>
                                <span>Configure como e quando as conversas serão criadas na plataforma e como será o atendimento após a resposta do contato</span>
                                <v-col cols="12">
                                    <v-radio-group v-model="object.conversation_creation_rule" row hide-details="auto">
                                        <v-radio label="Criar conversa para todos os envios da campanha" value="all"></v-radio>
                                        <v-radio label="Criar conversa apenas quando o contato responder" value="on_response"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-col>

                            <v-col cols="12">
                                <v-row v-if="object.conversation_creation_rule === 'all'">
                                    <v-col cols="12" lg="6" md="6" sm="12">
                                        <ib-select v-model="object.redirect" chips mandatory small-chips item-text="name" item-value="id" :items="redirects" label="Tipo de conversa" color="primary" outlined hide-details="auto" />
                                    </v-col>

                                    <v-col v-if="!object.redirect || object.redirect == 'ai_chatbot'" cols="12" lg="6" md="6" sm="12">
                                        <ib-select v-model="object.chatbot" chips mandatory small-chips item-text="name" item-value="_id" :items="chatbots" label="Chatbot" color="primary" outlined hide-details="auto" />
                                    </v-col>

                                    <v-col v-if="!object.redirect || object.redirect == 'flow_chatbot'" cols="12" lg="6" md="6" sm="12">
                                        <ib-select v-model="object.flow" chips mandatory small-chips item-text="name" item-value="_id" :items="flows" label="Fluxo" color="primary" outlined hide-details="auto" />
                                    </v-col>

                                    <v-col cols="12" lg="6" md="6" sm="12">
                                        <ib-select v-model="object.department" chips mandatory small-chips item-text="name" item-value="_id" :items="departments" label="Departamento" color="primary" outlined hide-details="auto" />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="d-flex flex-wrap">
                        <ib-btn outlined color="gray200" @click.native="getObjects(); dialogCreate = false">
                            <div class="gray1000--text">
                                Cancelar
                            </div>
                        </ib-btn>

                        <v-spacer />

                        <ib-btn class="my-1" color="primary" :loading="loading" @click.native="createNew">
                            Salvar
                        </ib-btn>
                    </v-card-actions>
                </v-card>
            </ib-dialog>

            <ib-dialog v-model="dialog" overlay-opacity="0.5" overlay-color="white" max-width="350">
                <v-card>
                    <ib-dialog-header title="Apagar campanha" :close="() => { dialog = false }"></ib-dialog-header>

                    <v-card-text>Tem certeza que deseja apagar a campanha <b>{{ object.name }}</b>?</v-card-text>

                    <v-card-actions>
                        <ib-btn outlined color="gray200" @click="dialog = false;">
                            <div class="gray1000--text">
                                Cancelar
                            </div>
                        </ib-btn>

                        <v-spacer />

                        <ib-btn color="error" @click="dialog = false; deleteObject(object)">
                            Apagar
                        </ib-btn>
                    </v-card-actions>
                </v-card>
            </ib-dialog>

            <ib-dialog v-model="dialog2" overlay-opacity="0.5" overlay-color="white" max-width="350">
                <v-card>
                    <ib-dialog-header title="Cancelar campanha" :close="() => { dialog2 = false }"></ib-dialog-header>

                    <v-card-text>Tem certeza que deseja cancelar a campanha <b>{{ object.name }}</b>?</v-card-text>
                    <v-card-actions>
                        <ib-btn outlined color="gray200" @click="dialog2 = false;">
                            <div class="gray1000--text">
                                Não
                            </div>
                        </ib-btn>

                        <v-spacer />

                        <ib-btn color="error" @click="dialog2 = false; cancelObject(object)">
                            Sim, tenho certeza
                        </ib-btn>
                    </v-card-actions>
                </v-card>
            </ib-dialog>
        </div>

        <video-dialog v-model="showVideo" videoUrl="https://www.youtube.com/embed/64x46-3SGk4?rel=0" />
    </div>
</template>

<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";
import VideoDialog from "@/components/VideoDialog.vue";

export default {
    name: "CampanhasView",

    components: {
        VideoDialog
    },

    data() {
        return {
            objects: [],
            showVideo: false,
            object: { message: [""], scheduled: false, message_type: "text", scheduledTo: "", conversation_creation_rule: 'all' },
            chips: [],
            audiences: [],
            flows: [],
            templates: [],
            departments: [],
            chatbots: [],
            selectedItem: {},
            types: [
                { name: "Audiência cadastrada", id: "audience" },
                { name: "Por tags", id: "tags" },
            ],
            tags: [],
            statuses: {
                "scheduled": "Agendada",
                "error": "Erro",
                "finished": "Concluída",
                "canceled": "Cancelada",
                "started": "Iniciada",
            },
            redirects: [{ name: 'Chatbot de IA', id: 'ai_chatbot' }, { name: 'Chatbot de Fluxo', id: 'flow_chatbot' }, { name: 'Atendimento humano', id: 'human' }],
            showAlert: false,
            showAlert2: false,
            dialog: false,
            dialog2: false,
            dialogCreate: false,
            loading: false,
            headers: [
                { text: 'Nome', value: 'name' },
                { text: 'Criação', value: 'created' },
                { text: 'Agendamento', value: 'scheduledTo' },
                { text: 'Público', value: 'audience' },
                { text: 'Alcance estimado', value: 'people_count' },
                { text: 'Envios realizados', value: 'sent_messages' },
                { text: "Status", value: "status", sortable: false },
                { text: "Ações", value: "actions", sortable: false }
            ]
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser;
        }
    },

    async beforeDestroy() {

    },

    async mounted() {
        if (!this.currentUser?.access_areas?.includes('campaigns')) {
            emitToastr("error", "Permissões insuficientes.");
            this.$router.replace({ name: 'Atendimento' });
        }

        this.getTags();
        this.startSocket();
        await this.getObjects();

        const chips_call = Api.getChipNumbersByUser();
        const audiences_call = Api.getAudienceByUser();
        const flows_call = Api.getFlowsByUser();
        const templates_call = Api.getTemplateMessages();
        const departments_call = Api.getDepartmentsByUser();
        const chatbots_call = Api.getChatbotsByUser();

        const [chips, audiences, flows, templates, departments, chatbots] = await Promise.all([chips_call, audiences_call, flows_call, templates_call, departments_call, chatbots_call]);

        if (!chips.error && chips.message) {
            this.chips = chips.message.filter(c => c.status == 'open' && c.official);
            if (this.chips.length < 1) this.showAlert = true;
        }

        if (!audiences.error && audiences.message) this.audiences = audiences.message;
        if (this.audiences.length < 1) this.showAlert2 = true;

        if (!flows.error && flows.message) this.flows = flows.message;

        if (!this.departments.error && departments.message) this.departments = departments.message;

        if (!this.chatbots.error && chatbots.message) this.chatbots = chatbots.message;

        if (!templates.error && templates.message) this.templates = templates.message.filter(t => t.status === 'APPROVED');
    },

    methods: {
        async getObjects() {
            const resp = await Api.getCampaignsByUser({ official: true });

            if (!resp.error && resp.message) {
                this.objects = resp.message;
            }
        },

        templateChanged(template) {
            const buttons = template.components.find(c => c.type === 'BUTTONS');
            this.object.template_payloads = [];

            if (buttons && buttons.buttons) {
                buttons.buttons.forEach(b => {
                    if (b.type === "QUICK_REPLY") this.object.template_payloads.push({ type: 'button', button: b.text, tip: `Se o contato clicar em ${b.text}`, payload: '' });
                });
            }

            const body = template.components.find(c => c.type === 'BODY');
            const parameters = this.extractParameters(body.text);

            if (parameters.count) {
                this.object.template_parameters = [];
                parameters.list.forEach(item => this.object.template_parameters.push({ par: item, fallback: '', var: '' }))
            }

            this.$forceUpdate();
        },

        extractParameters(str, unique = true) {
            const re = /\{\{\s*(\d+)\s*\}\}/g;
            const found = [];

            for (const m of str.matchAll(re)) {
                found.push(Number(m[1]));
            }

            let list = found;
            if (unique) {
                const seen = new Set();
                list = found.filter(n => !seen.has(n) && (seen.add(n), true));
            }

            list = [...list].sort((a, b) => a - b);

            return { count: list.length, list: list };
        },


        startSocket() {

        },

        async getRealTimeData() {

        },

        async getTags() {
            const resp = await Api.getTagsByUser();

            if (!resp.error && resp.message) {
                this.tags = resp.message;
            }
        },

        getAudience(audience_id) {
            return this.audiences.find(a => a._id?.toString() == audience_id?.toString())?.name || "N/A";
        },

        callSupport() {
            window.open(`https://api.whatsapp.com/send?phone=5518981240097&text=Preciso falar com um humano`, "_blank");
        },

        async createNew() {
            if (!this.object.chip) return emitToastr("error", "Chip de envio necessário");
            if (!this.object.scheduledTo) return emitToastr("error", "Data e hora de envio necessária");

            if (!this.object.conversation_creation_rule) return emitToastr("error", "Necessário informar quando as conversas serão criadas");

            if (this.object.conversation_creation_rule === 'all') {
                if (!this.object.department) return emitToastr("error", "É necessário informar o departamento da conversa");
                if (!this.object.redirect) return emitToastr("error", "É necessário informar o tipo de conversa (chatbot, atendimento humano, fluxo)");
                if (this.object.redirect === 'ai_chatbot' && !this.object.chatbot) return emitToastr("error", "É necessário informar o chatbot");
                if (this.object.redirect === 'flow_chatbot' && !this.object.flow) return emitToastr("error", "É necessário informar o fluxo");
            }

            if (this.object.audience_type == 'audience') {
                if (!this.object.audience) return emitToastr("error", "Audiência necessária para formar o público de envio");
            }
            else {
                //TAGS
                if (!this.object.audience_tags || this.object.audience_tags.length == 0) return emitToastr("error", "Tags necessárias para formar o público de envio");
            }

            this.loading = true;
            const resp = await Api.createOrUpdateOfficialCampaign(this.object);
            this.loading = false;

            if (!resp.error) {
                this.object = { message: [""], scheduled: false, official: true, conversation_creation_rule: 'all' };
                this.dialogCreate = false;
                emitToastr("success", "Campanha cadastrada com sucesso.");
                setTimeout(() => {
                    this.getObjects();
                }, 2000);
            }
        },

        async deleteObject(object) {
            object.filed = true;
            await Api.createOrUpdateOfficialCampaign(object);
            this.getObjects();
            this.object = { message: [""], scheduled: false, message_type: "text", scheduledTo: "", conversation_creation_rule: 'all' }
        },

        async cancelObject(object) {
            object.cancel_now = true;
            await Api.createOrUpdateOfficialCampaign(object);
            this.getObjects();
            this.object = { message: [""], scheduled: false, message_type: "text", scheduledTo: "", conversation_creation_rule: 'all' }
        },

        openNew() {
            this.object = { message: [""], scheduled: false, message_type: "text", scheduledTo: "", conversation_creation_rule: 'all' }
            this.dialogCreate = true;
        },

        openObject(item) {
            item.scheduledTo = new Date(item.scheduledTo);
            this.object = item;
            this.dialogCreate = true;
        },

        duplicateObject(item) {
            let new_object = JSON.parse(JSON.stringify(item))

            delete new_object._id;
            delete new_object.delivery_data;
            delete new_object.sent_messages;
            delete new_object.people_count;
            delete new_object.status;
            delete new_object.created;
            delete new_object.finished;
            delete new_object.scheduledTo;
            delete new_object.started;

            this.object = new_object;
            this.dialogCreate = true;
        },
    },
};
</script>

<style scoped>
.content-title {
    margin-top: 8px;
    font-size: 16px;
    font-weight: 600;
}
</style>